var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 28,
    viewBox: "0 0 55 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.81854C1 2.81854 5.09014 -0.222514 7.92114 1.56049C10.7521 3.34349 9.44104 8.79565 12.321 9.94965C15.201 11.1036 14.9951 0.773443 17.9841 4.91644C20.9731 9.05944 19.5571 22.6906 22.5981 26.0986C25.6391 29.5066 26.5832 20.3836 28.6802 18.3386C30.7772 16.2936 30.934 19.4386 32.665 18.3386C34.396 17.2386 33.7651 13.9384 35.6011 13.9384C37.4371 13.9384 37.96 17.7136 40.001 18.3386C42.042 18.9636 41.8361 16.1386 43.7761 16.4516C45.7161 16.7646 45.297 19.5976 47.761 19.5976C50.225 19.5976 52.1611 17.2386 53.6331 16.4516",
    stroke: "#F7931A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpGraph);
export default __webpack_public_path__ + "static/media/up-graph.4b95b50c8a7bb137d4fadf9c0643830a.svg";
export { ForwardRef as ReactComponent };